import React, { useState } from "react";
import {
  Box,
  TextField,
  Switch,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  Grid,
  Typography,
  FormControlLabel,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import "./HealthInsurance.css";

const HealthInsurance = () => {
  const [hiStatus, setHiStatus] = useState(true);
  const [editable, setEditable] = useState(false);

  const [statutoryAmount, setStatutoryAmount] = useState(25000);
  const [employeeContribution, setEmployeeContribution] = useState(
    "Basic * 2%"
  );
  const [effectiveDate, setEffectiveDate] = useState("2020-04-01");

  const [enableCoverage, setEnableCoverage] = useState(true);
  const [lopDependant, setLopDependant] = useState(false);
  const [hiIncludedInCTC, setHiIncludedInCTC] = useState(true);
  const [additionalChargesIncluded, setAdditionalChargesIncluded] =
    useState(false);

  const contributionOptions = ["Basic * 2%", "Basic * 1.5%", "Gross * 2%"];

  const handleToggle = (e) => {
    setHiStatus(e.target.checked);
    if (!e.target.checked) setEditable(false);
  };

  const handleSave = () => {
    setEditable(false);
    // API save logic
  };

  return (
    <Box className="hi-wrapper">
      <Box className="hi-card">
        {/* Header */}
        <Box className="hi-header">
          <Typography className="hi-title">Health Insurance Status</Typography>
          <FormControlLabel
            control={<Switch checked={hiStatus} onChange={handleToggle} />}
            label={hiStatus ? "Enabled" : "Disabled"}
            labelPlacement="start"
          />
        </Box>

        {hiStatus && (
          <>
            {/* Form Fields */}
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Statutory Minimum Monthly Amount"
                  value={statutoryAmount.toLocaleString()}
                  onChange={(e) => {
                    const value = e.target.value.replace(/,/g, "");
                    if (!isNaN(value)) setStatutoryAmount(Number(value));
                  }}
                  fullWidth
                  disabled={!editable}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">₹</InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControl fullWidth disabled={!editable}>
                  <InputLabel>Employee Contribution</InputLabel>
                  <Select
                    value={employeeContribution}
                    onChange={(e) => setEmployeeContribution(e.target.value)}
                  >
                    {contributionOptions.map((opt) => (
                      <MenuItem key={opt} value={opt}>
                        {opt}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  label="Effective Date"
                  type="date"
                  value={effectiveDate}
                  onChange={(e) => setEffectiveDate(e.target.value)}
                  fullWidth
                  disabled={!editable}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>

            {/* Switches Section */}
            <Grid container spacing={2} className="hi-switches">
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={enableCoverage}
                      onChange={(e) => setEnableCoverage(e.target.checked)}
                      disabled={!editable}
                    />
                  }
                  label="Enable Coverage"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={hiIncludedInCTC}
                      onChange={(e) => setHiIncludedInCTC(e.target.checked)}
                      disabled={!editable}
                    />
                  }
                  label="Included in CTC"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={lopDependant}
                      onChange={(e) => setLopDependant(e.target.checked)}
                      disabled={!editable}
                    />
                  }
                  label="LOP Dependant"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={additionalChargesIncluded}
                      onChange={(e) =>
                        setAdditionalChargesIncluded(e.target.checked)
                      }
                      disabled={!editable}
                    />
                  }
                  label="Additional Charges Included"
                />
              </Grid>
            </Grid>

            {/* Action Buttons */}
            <Box className="hi-actions">
              {!editable ? (
                <Button
                  variant="contained"
                  startIcon={<EditIcon />}
                  onClick={() => setEditable(true)}
                >
                  Edit
                </Button>
              ) : (
                <>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => setEditable(false)}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default HealthInsurance;
